import requestSender from "@/api/base/requestSender";

const UrlPrefix = "evaluation/";

export default function (axiosInstance) {
    return {
        categorySearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-category/search', payload, options);
        },
        categoryCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-category/create', payload, options);
        },
        categoryUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-category/update', payload, options);
        },
        categoryDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-category/delete', payload, options);
        },

        competenceSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-competence/search', payload, options);
        },
        competenceGet(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-competence/get', payload, options);
        },
        competenceCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence/create', payload, options);
        },
        competenceUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence/update', payload, options);
        },
        competenceDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence/delete', payload, options);
        },

        indicatorSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-indicator/search', payload, options);
        },
        indicatorCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-indicator/create', payload, options);
        },
        indicatorUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-indicator/update', payload, options);
        },
        indicatorDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-indicator/delete', payload, options);
        },

        rangeSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-competence-range-recommendation/search', payload, options);
        },
        rangeCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence-range-recommendation/create', payload, options);
        },
        rangeUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence-range-recommendation/update', payload, options);
        },
        rangeDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence-range-recommendation/delete', payload, options);
        },

        recommendationSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-competence-recommendation/search', payload, options);
        },
        recommendationCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence-recommendation/create', payload, options);
        },
        recommendationUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence-recommendation/update', payload, options);
        },
        recommendationDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-competence-recommendation/delete', payload, options);
        },

        scaleSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-scale/search', payload, options);
        },
        scaleCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-scale/create', payload, options);
        },
        scaleUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-scale/update', payload, options);
        },
        scaleDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-scale/delete', payload, options);
        },

        optionSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-scale-option/search', payload, options);
        },
        optionCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-scale-option/create', payload, options);
        },
        optionUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-scale-option/update', payload, options);
        },
        optionDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-scale-option/delete', payload, options);
        },

        profileSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-profile/search', payload, options);
        },
        profileGet(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-profile/get', payload, options);
        },
        profileCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile/create', payload, options);
        },
        profileUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile/update', payload, options);
        },
        profileDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile/delete', payload, options);
        },

        profileCompetenceSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-profile-competence/search', payload, options);
        },
        profileCompetenceCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile-competence/create', payload, options);
        },
        profileCompetenceUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile-competence/update', payload, options);
        },
        profileCompetenceDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile-competence/delete', payload, options);
        },

        profileUserSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-profile-user/search', payload, options);
        },
        profileUserCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile-user/create', payload, options);
        },
        profileUserDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-profile-user/delete', payload, options);
        },

        evaluationSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-evaluation/search', payload, options);
        },
        evaluationGet(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-evaluation/get', payload, options);
        },
        evaluationCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/create', payload, options);
        },
        evaluationUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/update', payload, options);
        },
        evaluationDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/delete', payload, options);
        },
        evaluationNextStep(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/next-step', payload, options);
        },
        evalEvaluationGetResult(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-evaluation/get-result-evaluation', payload, options);
        },
        evalRemind(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/eval-remind', payload, options);
        },

        evaluationSettingUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/setting-update', payload, options);
        },

        questionSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-evaluation/extra-question-search', payload, options);
        },
        questionCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/extra-question-create', payload, options);
        },
        questionUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/extra-question-update', payload, options);
        },
        questionDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation/extra-question-delete', payload, options);
        },

        evaluationUserSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-evaluation-user/search', payload, options);
        },
        evaluationUserCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation-user/create', payload, options);
        },
        evaluationUserDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation-user/delete', payload, options);
        },
        evaluationUserUpdate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-evaluation-user/update', payload, options);
        },
        evaluationUserGet(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-evaluation-user/get-evaluation-user', payload, options);
        },

        evaluatorsSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-evaluation-evaluator/search', payload, options);
        },

        myEvaluationSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-my-evaluation/search', payload, options);
        },
        myEvaluationGet(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-my-evaluation/get', payload, options);
        },
        myEvaluationColleaguesDelete(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-my-evaluation/colleagues-delete', payload, options);
        },
        myEvaluationColleaguesSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-my-evaluation/colleagues-search', payload, options);
        },
        myEvaluationAllColleaguesSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-my-evaluation/all-colleagues-search', payload, options);
        },
        myEvaluationColleagueCreate(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-my-evaluation/colleagues-create', payload, options);
        },
        myEvaluationGetCompetencies(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-my-evaluation/get-competencies', payload, options);
        },
        myEvaluationSaveEvaluationScore(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-my-evaluation/save-evaluation-score', payload, options);
        },
        myEvaluationFinishEvaluation(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-my-evaluation/finish-evaluation', payload, options);
        },
        myEvaluationGetResult(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-my-evaluation/get-result-evaluation', payload, options);
        },
        myEvaluationSaveExtraQuestion(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-my-evaluation/save-extra-question', payload, options);
        },

        requestsSearch(payload, options) {
            return requestSender('get', UrlPrefix + 'eval-request/search', payload, options);
        },
        requestsApprove(payload, options) {
            return requestSender('post', UrlPrefix + 'eval-request/approve', payload, options);
        },
    }
}